import axios from 'axios';

export default {
    namespaced: true,
    state: {
        upcomingRentals: null,
        loadingUpcomingRentals: false,

        historicRentals: null,
        loadingHistoricRentals: false,

        rentalDetail: null,
        loadingRental: false
    },
    getters: {
        upcomingRentalCount(state) {
            return state.upcomingRentals ? state.upcomingRentals.length : null;
        }
    },
    mutations: {
        // upcoming rentals
        loadUpcomingRentals(state) {
            state.loadingUpcomingRentals = true;
        },
        resetUpcomingRentals(state) {
            state.upcomingRentals = null;
        },
        updateUpcomingRentals(state, upcomingRentals) {
            state.upcomingRentals = upcomingRentals;
            state.loadingUpcomingRentals = false;
        },

        // historic rentals
        loadHistoricRentals(state) {
            state.loadingHistoricRentals = true;
        },
        resetHistoricRentals(state) {
            state.historicRentals = null;
        },
        updateHistoricRentals(state, historicRentals) {
            state.historicRentals = historicRentals;
            state.loadingHistoricRentals = false;
        },

        // rental details
        loadRental(state) {
            state.loadingRental = true;
        },
        resetRetalDetail(state) {
            state.rentalDetail = null;
        },
        updateRentailDetails(state, rentalDetails) {
            state.rentalDetails = rentalDetails;
            state.loadingRental = false;
        }
    },
    actions: {
        getUpcomingRentals({ commit }) {
            commit('resetUpcomingRentals');
            commit('loadUpcomingRentals');
            axios
                .get('/upcoming-rentals')
                .then(result => {
                    commit('updateUpcomingRentals', result.data.data);
                })
                .catch(console.error);
        },
        getHistoricRentals({ commit }) {
            commit('resetHistoricRentals');
            commit('loadHistoricRentals');
            axios
                .get('/historic-rentals')
                .then(result => {
                    commit('updateHistoricRentals', result.data.data);
                })
                .catch(console.error);
        },
        getRental({ commit }, id) {
            commit('resetRetalDetail');
            commit('loadRental');
            axios
                .get('/rental/' + id)
                .then(result => {
                    commit('updateRentailDetails', result.data.data);
                })
                .catch(console.error);
        }
    }
};
